module.exports = __webpack_public_path__ + "img/clipboard.211f422a.svg";